import { Interweave } from "interweave"
import { mergeSearchHighlights } from "@/lib/searchHighlight"

export default function SearchHighlightedText({ html }: { html: string }) {
  return (
    <Interweave
      content={mergeSearchHighlights(html)}
      transform={(node, children) =>
        node.tagName === "MARK" ? (
          <mark className="rounded-sm bg-primary/15 px-0.5 text-foreground">
            {children}
          </mark>
        ) : undefined
      }
    />
  )
}
